"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convert_data = exports.convert_links = exports.convert_nodes = exports.convert_tags = exports.compute_flux_max = exports.convert_boolean = exports.compute_initial_colors = exports.complete_sankey_data = void 0;
const colormap_1 = __importDefault(require("colormap"));
const normalize_name = (name) => {
    const new_name = name.split('\\n').join('').split(' ').join('');
    return new_name;
};
const complete_sankey_data = (data, default_sankey_data, default_node, default_link) => {
    const { nodes, links } = data;
    const the_data = default_sankey_data();
    Object.assign(the_data, data);
    Object.assign(data, the_data);
    Object.values(nodes).forEach(n => {
        const nn = default_node(data);
        nn.x = undefined;
        nn.y = undefined;
        Object.assign(nn, n);
        Object.assign(n, nn);
    });
    Object.values(links).forEach(l => {
        const ll = default_link(data);
        Object.assign(ll, l);
        Object.assign(l, ll);
    });
    Object.values(data.nodeTags).forEach(tags_group => {
        if (tags_group.activated == undefined) {
            tags_group.activated = true;
        }
        if (tags_group.show_legend === undefined) {
            tags_group.show_legend = false;
        }
        if (tags_group.color_map === undefined) {
            tags_group.color_map = 'jet';
        }
    });
    Object.values(data.fluxTags).forEach(tags_group => {
        if (tags_group.activated == undefined) {
            tags_group.activated = true;
        }
        if (tags_group.show_legend === undefined) {
            tags_group.show_legend = false;
        }
        if (tags_group.color_map === undefined) {
            tags_group.color_map = 'jet';
        }
    });
    Object.values(data.dataTags).forEach(tags_group => {
        if (tags_group.activated == undefined) {
            tags_group.activated = true;
        }
        if (tags_group.show_legend === undefined) {
            tags_group.show_legend = false;
        }
        if (tags_group.color_map === undefined) {
            tags_group.color_map = 'jet';
        }
    });
    if (data.nodeTags['Type de noeud']) {
        data.nodeTags['Type de noeud'].banner = 'none';
        if (data.nodeTags['Type de noeud'].tags.produit && !data.nodeTags['Type de noeud'].tags.produit.shape) {
            data.nodeTags['Type de noeud'].tags.produit.shape = 'ellipse';
        }
        if (data.nodeTags['Type de noeud'].tags.secteur && !data.nodeTags['Type de noeud'].tags.secteur.shape) {
            data.nodeTags['Type de noeud'].tags.secteur.shape = 'rect';
        }
        if ('échange' in data.nodeTags['Type de noeud'].tags && !data.nodeTags['Type de noeud'].tags['échange'].shape) {
            data.nodeTags['Type de noeud'].tags['échange'].shape = 'rect';
        }
    }
    exports.compute_initial_colors(data);
    exports.convert_boolean(data);
    exports.compute_flux_max(data);
    if (data.show_structure == 'free') {
        data.show_structure = 'free_interval';
    }
};
exports.complete_sankey_data = complete_sankey_data;
const compute_initial_colors = (data) => {
    Object.values(data.nodeTags).forEach(tags_group => {
        if (Object.values(tags_group.tags).filter(tag => tag.color !== '').length === 0) {
            const nb_tags = Object.keys(tags_group.tags).length;
            if (tags_group.color_map === 'custom') {
                return;
            }
            const colors = colormap_1.default({
                colormap: tags_group.color_map,
                nshades: Math.max(11, nb_tags),
                format: 'hex',
                alpha: 1
            });
            let step = 1;
            if (nb_tags < 11) {
                step = Math.round(11 / nb_tags);
            }
            Object.keys(tags_group.tags).forEach((tag_key, i) => tags_group.tags[tag_key].color = colors[i * step]);
        }
    });
    Object.values(data.fluxTags).forEach(tags_group => {
        if (Object.values(tags_group.tags).filter(tag => tag.color !== '').length === 0) {
            const nb_tags = Object.keys(tags_group.tags).length;
            if (tags_group.color_map === 'custom') {
                return;
            }
            const colors = colormap_1.default({
                colormap: tags_group.color_map,
                nshades: Math.max(11, nb_tags),
                format: 'hex',
                alpha: 1
            });
            let step = 1;
            if (nb_tags < 11) {
                step = Math.round(11 / nb_tags);
            }
            Object.keys(tags_group.tags).forEach((tag_key, i) => tags_group.tags[tag_key].color = colors[i * step]);
        }
    });
};
exports.compute_initial_colors = compute_initial_colors;
const convert_boolean = (data) => {
    //data.display_style.unit = Boolean(data.display_style.unit)
    Object.values(data.nodes).forEach(n => {
        n.node_visible = Boolean(n.node_visible);
        n.show_value = Boolean(n.show_value);
        n.label_visible = Boolean(n.label_visible);
        n.shape_visible = Boolean(n.shape_visible);
        n.node_visible = Boolean(n.node_visible);
        n.display = Boolean(n.display);
    });
    Object.values(data.links).forEach(l => {
        l.label_visible = Boolean(l.label_visible);
    });
    Object.values(data.nodeTags).forEach(tags_group => {
        Object.values(tags_group.tags).forEach(tag => tag.selected = Boolean(tag.selected));
        tags_group.activated = Boolean(tags_group.activated);
    });
    Object.values(data.fluxTags).forEach(tags_group => {
        Object.values(tags_group.tags).forEach(tag => tag.selected = Boolean(tag.selected));
        tags_group.activated = Boolean(tags_group.activated);
    });
    Object.values(data.dataTags).forEach(tags_group => {
        Object.values(tags_group.tags).forEach(tag => tag.selected = Boolean(tag.selected));
        tags_group.activated = Boolean(tags_group.activated);
    });
};
exports.convert_boolean = convert_boolean;
const compute_flux_max = (data) => {
    let flux_max = 0;
    const compute_flux_max_internal = (dataTags, v, depth, flux_max) => {
        if (dataTags.length == 0 || depth === dataTags.length) {
            if (v.value && v.value > flux_max) {
                flux_max = v.value;
            }
            return flux_max;
        }
        const dataTag = Object.values(dataTags)[depth];
        const listKey = Object.keys(dataTag.tags);
        for (const i in listKey) {
            if (v[listKey[i]]) {
                if (v === undefined) {
                    //console.log(listKey[i] + ' not found in v')
                    break;
                }
                flux_max = compute_flux_max_internal(dataTags, v[listKey[i]], depth + 1, flux_max);
            }
        }
        return flux_max;
    };
    const dataTagsArray = Object.values(data.dataTags).filter(dataTag => { return (Object.keys(dataTag.tags).length != 0) ? true : false; });
    Object.values(data.links).forEach(l => {
        flux_max = compute_flux_max_internal(dataTagsArray, l.value, 0, flux_max);
    });
    if (data.display_style.filter_label === undefined) {
        data.display_style.filter_label = flux_max / 10;
    }
};
exports.compute_flux_max = compute_flux_max;
const convert_tags = (data) => {
    const data_to_convert = data;
    if (data_to_convert.tags_catalog) {
        data.nodeTags = Object.assign(data_to_convert.tags_catalog);
    }
    delete data_to_convert.tags_catalog;
    if (Array.isArray(data_to_convert.nodeTags)) {
        data.nodeTags = Object.assign({}, ...data_to_convert.nodeTags.map((tags_group) => ({
            [tags_group.group_name]: {
                group_name: tags_group.group_name,
                show_legend: tags_group.show_legend,
                tags: Object.assign({}, ...tags_group.tags.map((tag_name) => ({ [tag_name]: { name: tag_name, color: '', selected: tags_group.selected_tags.includes(tag_name) } }))),
                banner: tags_group.group_name === 'Regions' || tags_group.group_name === 'Periods' || tags_group.group_name === 'dimension' ? 'one' : 'multi'
            }
        })));
    }
    if (data.nodeTags['Regions']) {
        data.dataTags['Regions'] = JSON.parse(JSON.stringify(data.nodeTags['Regions']));
        delete data.nodeTags['Regions'];
    }
    if (data.nodeTags['Periods']) {
        data.dataTags['Periods'] = JSON.parse(JSON.stringify(data.nodeTags['Periods']));
        delete data.nodeTags['Periods'];
    }
    if (data.nodeTags['flux_types']) {
        data.fluxTags['flux_types'] = {
            group_name: 'Type de donnée',
            show_legend: false,
            color_map: 'custom',
            tags: {
                initial_data: { name: 'Données collectées', selected: true, color: 'cyan' },
                computed_data: { name: 'Données calculées', selected: true, color: 'blue' },
            },
            banner: 'multi',
            activated: true,
            siblings: []
        };
        delete data.nodeTags['flux_types'];
    }
    if (data.nodeTags['Uncert']) {
        data.fluxTags['Uncert'] = JSON.parse(JSON.stringify(data.nodeTags['Uncert']));
        data.fluxTags['Uncert'].banner = 'multi';
        delete data.nodeTags['Uncert'];
    }
    if (data.nodeTags['SubChain']) {
        data.nodeTags['SubChain'].group_name = 'Sous-Filières';
    }
    Object.entries(data.dataTags).forEach(([key, tags_group]) => {
        if (tags_group.banner === 'display' || key === 'flux_types' || key === 'Uncert') {
            data.fluxTags[key] = Object.assign({}, tags_group);
            data.fluxTags[key].banner = 'none';
        }
    });
    const new_dataTags = Object.entries(data.dataTags).filter(([key, tag_group]) => tag_group.banner !== 'display' && key !== 'flux_types' && key !== 'Uncert');
    data.dataTags = Object.assign({}, ...new_dataTags.map(([key, v]) => ({ [key]: Object.assign({}, v) })));
    const has_product = Object.values(data.nodes).filter(n => n.type === 'product').length > 0;
    if (has_product) {
        if (!('Type de noeud' in data.nodeTags)) {
            data.nodeTags['Type de noeud'] = {
                group_name: 'Type de noeud',
                tags: {
                    'produit': {
                        name: 'produit',
                        selected: true,
                        color: '',
                        shape: 'ellipse'
                    },
                    'secteur': {
                        name: 'secteur',
                        selected: true,
                        color: '',
                        shape: 'rect'
                    },
                    'échange': {
                        name: 'échange',
                        selected: true,
                        color: '',
                        shape: 'rect'
                    }
                },
                color_map: '',
                show_legend: false,
                banner: 'none',
                activated: true,
                siblings: []
            };
        }
    }
    if (data.nodeTags['Type de noeud']) {
        data.nodeTags['Type de noeud'].banner = 'none';
        if (data.nodeTags['Type de noeud'].tags.produit && !data.nodeTags['Type de noeud'].tags.produit.shape) {
            data.nodeTags['Type de noeud'].tags.produit.shape = 'ellipse';
        }
        if (data.nodeTags['Type de noeud'].tags.secteur && !data.nodeTags['Type de noeud'].tags.secteur.shape) {
            data.nodeTags['Type de noeud'].tags.secteur.shape = 'rect';
        }
        if ('échange' in data.nodeTags['Type de noeud'].tags && !data.nodeTags['Type de noeud'].tags['échange'].shape) {
            data.nodeTags['Type de noeud'].tags['échange'].shape = 'rect';
        }
    }
    if (data.nodeTags.Dimensions) {
        Object.keys(data.nodeTags.Dimensions.tags).forEach(tag => {
            data.nodeTags[tag] = {
                group_name: data.nodeTags.Dimensions.tags[tag].name,
                color_map: 'jet',
                show_legend: false,
                banner: 'level',
                tags: {},
                activated: true,
                siblings: []
            };
            Object.values(data.nodes).forEach(n => {
                var _a;
                if (n.dimensions[tag]) {
                    n.tags[tag] = [String(((_a = n.dimensions[tag].level) !== null && _a !== void 0 ? _a : 0))];
                }
                if ('Dimensions' in n.tags) {
                    delete n.tags.Dimensions;
                }
            });
            let max_level = 1;
            Object.values(data.nodes).forEach(n => {
                var _a, _b;
                if (n.dimensions[tag] && ((_a = n.dimensions[tag].level) !== null && _a !== void 0 ? _a : 0) > max_level) {
                    max_level = (_b = n.dimensions[tag].level) !== null && _b !== void 0 ? _b : 0;
                }
            });
            Object.values(data.nodes).forEach(n => {
                if (n.dimensions[tag]) {
                    const dim_desagregate_nodes = Object.values(data.nodes).filter(n2 => n2.dimensions[tag] && n2.dimensions[tag].parent_name === n.idNode);
                    if (dim_desagregate_nodes.length == 0) {
                        for (let level = 2; level <= max_level; level++) {
                            n.tags[tag].push(String(level));
                        }
                    }
                }
            });
            for (let level = 1; level <= max_level; level++) {
                data.nodeTags[tag]['tags'][String(level)] = {
                    name: String(level),
                    selected: level == 1
                };
            }
        });
        delete data.nodeTags.Dimensions;
    }
    if (data_to_convert.nodeTags['Exchanges']) {
        //data_to_convert.nodeTags['Exchanges'].group_name = 'Echanges'
        delete data_to_convert.nodeTags['Exchanges'];
        // if (!('Echanges' in data.nodeTags)) {
        //   data.nodeTags.Dimensions.tags['Echanges'] = {
        //     name : 'Echanges',
        //     selected: false
        //   }
        // }
    }
    const subchains = [];
    Object.values(data.links).forEach(l => {
        const l_convert = l;
        const source_node = data.nodes[l.idSource];
        const target_node = data.nodes[l.idTarget];
        if (!source_node || !target_node) {
            return;
        }
        if (l_convert.subchain && l_convert.subchain !== '') {
            l_convert.subchain.split(',').forEach(s => {
                if (!subchains.includes(s)) {
                    subchains.push(s);
                }
            });
            delete l_convert.subchain;
        }
    });
    Object.values(data.nodes).forEach(n => {
        const n_convert = n;
        if (n_convert.subchain && n_convert.subchain !== '') {
            n.tags['SubChain'] = n_convert.subchain.split(',');
            n_convert.subchain.split(',').forEach(s => {
                if (!subchains.includes(s)) {
                    subchains.push(s);
                }
            });
            delete n_convert.subchain;
        }
    });
    if (data_to_convert.subchains && data_to_convert.subchains[0] !== '') {
        const cpySbchaine = data_to_convert.subchains;
        if (Object.entries(data.nodeTags).filter(tags_group => tags_group[0] === 'SubChain').length === 0) {
            const tags_dict = Object.assign({}, ...cpySbchaine.map((subchain) => ({ [subchain]: { name: subchain, color: 'red', selected: true } })));
            data.nodeTags['SubChain'] = {
                group_name: 'Sous-Filières',
                color_map: 'jet',
                show_legend: false,
                tags: tags_dict,
                banner: 'multi',
                activated: true,
                siblings: []
            };
            delete data_to_convert.subchains;
        }
    }
    else if (subchains.length > 0) {
        const tags_dict = Object.assign({}, ...subchains.map((subchain) => ({ [subchain]: { name: subchain, color: 'red', selected: true } })));
        if (Object.entries(data.nodeTags).filter(tags_group => tags_group[0] === 'SubChain').length === 0) {
            data.nodeTags['SubChain'] = {
                group_name: 'Sous-Filières',
                show_legend: false,
                color_map: 'jet',
                tags: tags_dict,
                banner: 'multi',
                activated: true,
                siblings: []
            };
        }
    }
    if ((data_to_convert.flux_types || data_to_convert.use_flux_types) && data.version !== '0.7' && data.version !== '0.8') {
        if (!data.fluxTags['flux_types']) {
            data.fluxTags['flux_types'] = {
                group_name: 'Type de donnée',
                show_legend: false,
                color_map: 'custom',
                tags: {
                    'initial_data': { name: 'Données collectées', selected: true, color: '#696969' },
                    'computed_data': { name: 'Données calculées', selected: true, color: '#D3D3D3' },
                },
                banner: 'multi',
                activated: true,
                siblings: []
            };
            delete data_to_convert.flux_types;
            delete data_to_convert.use_flux_types;
        }
    }
    if (data.fluxTags['flux_types']) {
        if (data.fluxTags['flux_types'].tags.initial_data.color === '') {
            data.fluxTags['flux_types'].tags.initial_data.color = '#696969'; //DimGray
        }
        if (data.fluxTags['flux_types'].tags.computed_data.color === '') {
            data.fluxTags['flux_types'].tags.computed_data.color = '#D3D3D3'; //LightGray
        }
    }
    if (!('Primaire' in data.nodeTags)) {
        data.nodeTags['Primaire'] = {
            group_name: 'Primaire',
            show_legend: false,
            color_map: 'custom',
            tags: {
                '1': { name: '1', selected: true, color: '#696969' }
            },
            banner: 'level',
            activated: true,
            siblings: []
        };
    }
};
exports.convert_tags = convert_tags;
const convert_nodes = (data) => {
    const data_to_convert = data;
    if (Object.keys(data.nodes).length > 0 && !Object.values(data.nodes)[0].idNode) {
        Object.values(data.nodes).forEach(n => n.idNode = 'node' + n.id);
    }
    Object.values(data.nodes).forEach(n => {
        if (n.input_links) {
            n.inputLinksId = [];
            n.outputLinksId = [];
            n.input_links.forEach(link_idx => {
                n.inputLinksId.push(data.links['link' + link_idx].idLink);
            });
            n.output_links.forEach(link_idx => {
                n.outputLinksId.push(data.links['link' + link_idx].idLink);
            });
            delete n.output_links;
            delete n.input_links;
            delete n.id;
        }
    });
    const has_product = Object.values(data.nodes).filter(n => n.type === 'product').length > 0;
    Object.values(data.nodes).forEach(n => {
        const n_convert = n;
        if (Object.keys(data.nodes).length > 0 && !Object.values(data.nodes)[0].idNode) {
            Object.values(data.nodes).forEach(n => n.idNode = 'node' + n.id);
        }
        if (n.display_style.label_vert === 'bottom' && n.display_style.label_horiz === 'right') {
            n.display_style.label_horiz = 'middle';
        }
        if (n.display_style.label_vert === 'haut') {
            n.display_style.label_vert = 'top';
        }
        if (n.display_style.label_vert === 'milieu') {
            n.display_style.label_vert = 'middle';
        }
        if (n.display_style.label_vert === 'bas') {
            n.display_style.label_vert = 'bottom';
        }
        if (n.display_style.label_horiz === 'droite') {
            n.display_style.label_horiz = 'right';
        }
        if (n.display_style.label_horiz === 'milieu') {
            n.display_style.label_horiz = 'middle';
        }
        if (n.display_style.label_horiz === 'gauche') {
            n.display_style.label_horiz = 'left';
        }
        if (n.display_style.font_family === undefined) {
            n.display_style.font_family = 'Arial,serif';
        }
        if (n.node_width === undefined) {
            if (data_to_convert.node_width) {
                n.node_width = data_to_convert.node_width;
            }
            else {
                n.node_width = 10;
            }
        }
        if (n.node_height === undefined) {
            if (data_to_convert.node_height) {
                n.node_height = data_to_convert.node_height;
            }
            else {
                n.node_height = 10;
            }
        }
        if (n_convert.definition) {
            n.tooltip_text = n_convert.definition;
            delete n_convert.definition;
        }
        if (n.x === undefined) {
            n.x = 0;
        }
        if (n.y === undefined) {
            n.y = 0;
        }
        // if (n_convert.visible === undefined && !n.node_visible && data.version !== '0.5' ) {
        //   n.shape_visible = true
        // }
        if (n_convert.visible === 1) {
            n.shape_visible = true;
        }
        if (n_convert.visible === 0) {
            n.shape_visible = false;
        }
        delete n_convert.visible;
        if (n.node_visible === undefined) {
            n.node_visible = n.shape_visible || n.label_visible;
        }
        // if (n.iconName === undefined) {
        //   n.iconName = 'none'
        // }
        // if (n.iconColor === undefined) {
        //   n.iconColor = '#fff'
        // }
        // if (n.iconRatio === undefined) {
        //   n.iconRatio = 80
        // }
        // if (n.iconVisible === undefined) {
        //   n.iconVisible = true
        // }
        if (n_convert.type) {
            n.shape = n_convert.type === 'product' ? 'ellipse' : 'rect';
            if (has_product && !n.tags['Type de noeud']) {
                n.tags['Type de noeud'] = [];
            }
            if (has_product && n.tags['Type de noeud'].length === 0) {
                n.tags['Type de noeud'].push(n_convert.type === 'product' ? 'produit' : 'secteur');
            }
            delete n_convert.type;
        }
        delete n_convert.visible;
        n.name = n.name.split('\\n').join(' ');
        const attributes_to_remove = ['tooltips', 'total_input_offset', 'input_offsets', 'total_output_offset', 'output_offsets', 'horizontal_index', 'title_length', 'old_color'];
        for (const attr in attributes_to_remove) {
            if (attributes_to_remove[attr] in n_convert) {
                delete n_convert[attributes_to_remove[attr]];
            }
        }
        if (n.name.includes('(I') && n.outputLinksId.length > 0 && data.nodeTags['Exchanges']) {
            n.node_visible = true;
            if (data_to_convert.display_style.trade_close !== undefined) {
                n_convert.trade_close = data_to_convert.display_style.trade_close;
            }
        }
        else if (n.name.includes('(E') && !n.name.includes('(EA)') && data.nodeTags['Exchanges']) {
            n.node_visible = true;
            if (data_to_convert.display_style.trade_close !== undefined) {
                n_convert.trade_close = data_to_convert.display_style.trade_close;
            }
        }
        if (n.tags && n.tags['Exchanges'] && n.tags['Exchanges'].length > 0 && (n.tags['Exchanges'][0].includes('mport') || n.tags['Exchanges'][0].includes('xport')) && n_convert.trade_close && !n.position) {
            n.position = 'relative';
            n.x = n.tags['Exchanges'][0].includes('import') ? -data_to_convert.trade_close_hspace : data_to_convert.trade_close_hspace;
            n.y = n.tags['Exchanges'][0].includes('import') ? -data_to_convert.trade_close_vspace : data_to_convert.trade_close_vspace;
        }
        if (!('Primaire' in n.dimensions)) {
            n.dimensions['Primaire'] = { level: 1, parent_name: undefined };
        }
        if (n.tags['Exchanges'] && n.tags['Exchanges'][0] !== 'interior') {
            n.tags['Type de noeud'] = ['échange'];
            if (!n.dimensions) {
                n.dimensions = {};
            }
            if (data_to_convert.trade_sectors) {
                if (n.tags['Exchanges'][0].includes(data_to_convert.trade_sectors[0].split(' - ')[0])) {
                    n.dimensions = { 'Echanges': { level: 1, parent_name: undefined } };
                    //n.dimensions = { 'Primaire' : { level : 1, parent_name: undefined } }
                    if (!('Echanges' in n.tags)) {
                        n.tags.Echanges = [];
                    }
                    // if (!('Echanges' in n.tags.Dimensions)) {
                    //   n.tags.Dimensions.push('Echanges')
                    // }
                    // if (!('Primaire' in n.tags)) {
                    //   n.tags.Primaire = []
                    // }
                }
                else {
                    const names = n.name.split(' - ');
                    names[1] = data_to_convert.trade_sectors[0].split(' - ')[0];
                    const parent_name = names.join(' - ');
                    const parent_node = Object.values(data.nodes).filter(n => n.name === parent_name)[0];
                    if (parent_node) {
                        n.dimensions = { 'Echanges': { level: 2, parent_name: parent_node.idNode } };
                    }
                    // if ( 'Primaire' in n.dimensions) {
                    //   delete n.dimensions.Primaire
                    // }
                    if (!('Echanges' in n.tags)) {
                        n.tags.Echanges = [];
                    }
                    // if (!('Echanges' in n.tags.Dimensions)) {
                    //   n.tags.Dimensions.push('Echanges')
                    // }
                    // if ( 'Primaire' in n.tags.Dimensions) {
                    //   n.tags.Dimensions = n.tags.Dimensions.filter(dim=>dim!=='Primaire')
                    // }
                }
            }
        }
        delete n.tags['Exchanges'];
        if (n.shape == 'image') {
            n.shape = 'rect';
        }
        // Convert image to ForeignObject
        if (n.image) {
            n.has_FO = true;
            n.is_FO_raw = false;
            n.FO_content = n.image;
        }
    });
};
exports.convert_nodes = convert_nodes;
const convert_links = (data) => {
    const data_to_convert = data;
    if (!Array.isArray(data.links) && data.version !== '0.5' && data.version !== '0.6' && data.version !== '0.7' && data.version !== '0.8') {
        const key_names = Object.keys(data.links);
        const new_links = JSON.parse(JSON.stringify(data.links[key_names[0]]));
        new_links.forEach((link, i) => {
            link.value = [];
            link.display_value = [];
            const convert_link = link;
            if (convert_link.mini !== undefined && convert_link.maxi !== undefined) {
                convert_link.mini = [];
                convert_link.maxi = [];
            }
            if (convert_link.data_value !== undefined) {
                convert_link.data_value = [];
            }
            if (convert_link.data_source !== undefined) {
                convert_link.data_source = [];
            }
            if (convert_link.data_period !== undefined) {
                convert_link.data_period = [];
            }
            key_names.forEach(cur_key_name => {
                link.value.push(data_to_convert.links[cur_key_name][i].value);
                link.display_value.push(data_to_convert.links[cur_key_name][i].display_value);
                if (convert_link.mini !== undefined && convert_link.maxi !== undefined) {
                    convert_link.mini.push(data_to_convert.links[cur_key_name][i].mini);
                    convert_link.maxi.push(data_to_convert.links[cur_key_name][i].maxi);
                }
                if (convert_link.data_value !== undefined) {
                    convert_link.data_value.push(data_to_convert.links[cur_key_name][i].data_value);
                }
                if (convert_link.data_source !== undefined) {
                    convert_link.data_source.push(data_to_convert.links[cur_key_name][i].data_source);
                }
                if (convert_link.data_period !== undefined) {
                    convert_link.data_period.push(data_to_convert.links[cur_key_name][i].data_period);
                }
            });
        });
        new_links.forEach((l, i) => l.idLink = 'link' + i);
        data.links = Object.assign({}, ...new_links.map(l => ({ [l.idLink]: Object.assign({}, l) })));
        data.nodes.forEach((n, i) => n.idNode = 'node' + i);
        data.nodes = Object.assign({}, ...data.nodes.map((n) => ({ [n.idNode]: Object.assign({}, n) })));
        if (key_names.length > 1 && !data_to_convert.periods && data_to_convert.region_names) {
            data.dataTags['Regions'] = {
                group_name: 'Regions',
                color_map: 'jet',
                show_legend: false,
                tags: Object.assign({}, ...data_to_convert.region_names.map((region_name) => ({ [region_name]: { name: region_name, color: '', selected: region_name === data_to_convert.region_name } }))),
                banner: 'one',
                activated: true,
                siblings: []
            };
        }
        if (key_names.length > 1 && data_to_convert.periods) {
            data.dataTags['Periods'] = {
                group_name: 'Periods',
                color_map: 'jet',
                show_legend: false,
                tags: Object.assign({}, ...key_names.map((key_name) => ({ [key_name]: { name: key_name, color: '', selected: key_names[0] } }))),
                banner: 'one',
                activated: true,
                siblings: []
            };
        }
        delete data_to_convert.periods;
        delete data_to_convert.region_names;
        delete data_to_convert.region_name;
    }
    if (Array.isArray(data.links) && (data.version === '0.5' || data.version === '0.4' || !data.version)) {
        if (data.links.length > 0 && !data.links[0].idLink) {
            data.links.forEach((l, i) => l.idLink = 'link' + i);
        }
        if (data.nodes.length > 0 && !data.nodes[0].idNode) {
            data.nodes.forEach((n) => n.idNode = 'node' + n.id);
        }
        data_to_convert.links = Object.assign({}, ...data.links.map((l) => ({ [l.idLink]: Object.assign({}, l) })));
        data_to_convert.nodes = Object.assign({}, ...data.nodes.map((n) => ({ [n.idNode]: Object.assign({}, n) })));
    }
    if (Object.keys(data.links).length > 0 && !Object.values(data.links)[0].idLink) {
        Object.values(data.links).forEach((l, i) => l.idLink = 'link' + i);
    }
    Object.values(data.links).forEach(l => {
        if (l.source_name) {
            const source_node = Object.values(data.nodes).filter(n => normalize_name(n.name) === normalize_name(l.source_name))[0];
            const target_node = Object.values(data.nodes).filter(n => normalize_name(n.name) === normalize_name(l.target_name))[0];
            l.idSource = source_node.idNode;
            l.idTarget = target_node.idNode;
            delete l.source_name;
            delete l.target_name;
        }
    });
    Object.values(data.links).forEach(l => {
        const l_convert = l;
        if (l.colorParameter === undefined) {
            l.colorParameter = 'groupTag';
            l.colorTag = 'no_colormap';
        }
        if (data.version !== '0.6' && data.version !== '0.7' && data.version !== '0.8') {
            // if ( Array.isArray(l_convert.value) ) {
            //   (l_convert.value as number[]).forEach(v => {
            //     v = +v
            //   })
            // }
            if ('tags' in l) {
                delete (l.tags)['Exchanges'];
            }
        }
        const source_node = data.nodes[l.idSource];
        const target_node = data.nodes[l.idTarget];
        if (!source_node || !target_node) {
            return;
        }
        if (!('orientation' in l)) {
            l.orientation = 'hh';
            if (source_node.orientation === 'horizontal' && target_node.orientation === 'vertical') {
                l.orientation = 'vh';
            }
            else if (source_node.orientation === 'vertical' && target_node.orientation === 'horizontal') {
                l.orientation = 'hv';
            }
        }
        if ('frozen' in l) {
            delete l_convert.frozen;
        }
        if ('link_reverse' in l) {
            delete l_convert.link_reverse;
        }
        if ('display_unit' in l_convert) {
            l_convert.natural_unit = l_convert.display_unit;
            delete l_convert.display_unit;
        }
        if (('agregated_data_value' in l_convert)) {
            l_convert.data_value = l_convert.agregated_data_value;
            delete l_convert.agregated_data_value;
        }
        if (l_convert.type === 'short_link_arrow') {
            l.curved = false;
            l.arrow = true;
        }
        else if (l_convert.type === 'bezier_link_arrow') {
            l.curved = true;
            l.arrow = true;
        }
        else if (l_convert.type === 'bezier_link_classic') {
            l.curved = true;
            l.arrow = false;
        }
        const attributes_to_remove = ['source', 'target', 'id', 'classif', 'title_length', 'raw_value', 'old_display_value', 'old_color', 'y_sd_label', 'x_sd_label', 'type'];
        for (const attr in attributes_to_remove) {
            if (attributes_to_remove[attr] in l) {
                delete l[attributes_to_remove[attr]];
            }
        }
        if (data.version === '0.1') {
            const unit_index = l_convert.natural_unit ? data_to_convert.units_names.indexOf(l_convert.natural_unit) : -1;
            if (l_convert.conv && unit_index !== -1) {
                const natural_conv = l_convert.conv[unit_index];
                l_convert.conv.splice(1, 0, natural_conv);
            }
            l.curved = true;
            l.curvature = 1;
            if (l_convert.text_same_color === true) {
                l.text_color = l.color;
            }
            else {
                l.text_color = 'white';
            }
            delete l_convert.text_same_color;
            if (target_node.x < source_node.x) {
                l.recycling = true;
            }
        }
        else if (!('curvature' in l)) {
            l.curvature = 0.5;
        }
        if (data.version === '0.2') {
            if (target_node.x < source_node.x) {
                l.recycling = true;
            }
        }
        if (data.version === '0.1' || data.version === '0.2') {
            if (l_convert.natural_unit) {
                if (l_convert.natural_unit.includes('tonne')) {
                    l_convert.natural_unit = l_convert.natural_unit.replace('tonne', 't');
                    if (l_convert.natural_unit === 'k t') {
                        l_convert.natural_unit = 'kt';
                    }
                }
            }
            delete l.tooltip_text;
        }
        if (!('text_color' in l) || l_convert.text_same_color === false) {
            l.text_color = 'black';
        }
        else if (l_convert.text_same_color === true) {
            l.text_color = l.color;
        }
        else if (l_convert.text_same_color === 'same_color') {
            l.text_color = l.color;
        }
        delete l_convert.text_same_color;
    });
    if (data.version !== '0.6' && data.version !== '0.7' && data.version !== '0.8') {
        const links_no_type = data.links;
        Object.values(links_no_type).forEach((link) => {
            links_no_type[link.idLink].value2 = {};
        });
        let region_names = [];
        let period_names = [];
        if (data_to_convert.dataTags['Regions']) {
            region_names = Object.keys(data_to_convert.dataTags['Regions'].tags);
            region_names.forEach(region_name => Object.values(links_no_type).forEach((link) => links_no_type[link.idLink].value2[region_name] = {}));
        }
        else if (data_to_convert.dataTags['Periods']) {
            period_names = Object.keys(data_to_convert.dataTags['Periods'].tags);
            period_names.forEach(period_name => Object.values(links_no_type).forEach((link) => links_no_type[link.idLink].value2[period_name] = {}));
        }
        if (region_names.length > 0 || period_names.length > 0) {
            const reg_or_period_names = region_names.length > 0 ? region_names : period_names;
            reg_or_period_names.forEach((region_name, value_index) => {
                Object.values(links_no_type).forEach((link) => {
                    const editable_link = links_no_type[link.idLink];
                    editable_link.value2[region_name] = {
                        value: link.value[value_index],
                        display_value: link.display_value[value_index],
                        tags: {},
                        extension: {}
                    };
                    const sankey_link_value = editable_link.value2[region_name];
                    if (editable_link.mini !== undefined && editable_link.mini !== null) {
                        if (!sankey_link_value.extension) {
                            sankey_link_value.extension = {};
                        }
                        if (sankey_link_value.extension) {
                            sankey_link_value.extension.mini = editable_link.mini[value_index];
                            sankey_link_value.extension.maxi = editable_link.maxi[value_index];
                        }
                        //sankey_link_value['tags']['Uncert'] = ''
                        const p = (editable_link.maxi[value_index] - editable_link.mini[value_index]) / editable_link.value[value_index];
                        if (p <= 0.1) {
                            sankey_link_value['tags']['Uncert'] = '10_percent';
                        }
                        else if (p <= 0.25) {
                            sankey_link_value['tags']['Uncert'] = '25_percent';
                        }
                        else if (p <= 0.5) {
                            sankey_link_value['tags']['Uncert'] = '50_percent';
                        }
                        else {
                            sankey_link_value['tags']['Uncert'] = '50+_percent';
                        }
                    }
                    if (data_to_convert.dataTags['flux_types']) {
                        sankey_link_value['tags']['flux_types'] = 'computed_data';
                    }
                    if (editable_link.data_value !== undefined && editable_link.data_value !== null && sankey_link_value.extension) {
                        sankey_link_value.extension.data_value = editable_link.data_value[value_index];
                        if ('data_source' in editable_link) {
                            sankey_link_value.extension.data_source = editable_link.data_source[value_index];
                        }
                        if ('data_period' in editable_link) {
                            sankey_link_value.extension.data_period = editable_link.data_period[value_index];
                        }
                        sankey_link_value['tags']['flux_types'] = 'initial_data';
                    }
                });
            });
        }
        else {
            Object.values(links_no_type).forEach((link) => {
                const editable_link = links_no_type[link.idLink];
                let the_value = link.value;
                let the_display_value = link.display_value;
                if (the_display_value == undefined) {
                    the_display_value = '';
                }
                if (Array.isArray(link.value)) {
                    the_value = link.value[0];
                    the_display_value = link.display_value[0];
                }
                editable_link.value2 = {
                    value: the_value,
                    display_value: the_display_value,
                    tags: {},
                    extension: {}
                };
                const sankey_link_value = editable_link.value2;
                if (the_display_value.includes('[')) {
                    // Variables libres
                    let tmp;
                    if (the_display_value.includes('-')) {
                        tmp = the_display_value.split('-');
                    }
                    else if (the_display_value.includes(',')) {
                        tmp = the_display_value.split(',');
                    }
                    else if (the_display_value.includes('...')) {
                        tmp = the_display_value.split('...');
                    }
                    else if (the_display_value.includes('  ')) {
                        tmp = the_display_value.split('  ');
                    }
                    else {
                        tmp = the_display_value.split(' ');
                    }
                    const free_mini = Number(tmp[0].substring(1));
                    const free_maxi = Number(tmp[1].substring(0, tmp[1].length - 1));
                    sankey_link_value.extension.free_mini = free_mini;
                    sankey_link_value.extension.free_maxi = free_maxi;
                    editable_link.value2.display_value = '';
                }
                if (editable_link.mini !== undefined && editable_link.mini !== null) {
                    let the_mini = editable_link.mini;
                    let the_maxi = editable_link.maxi;
                    if (Array.isArray(editable_link.mini)) {
                        the_mini = editable_link.mini[0];
                        the_maxi = editable_link.maxi[0];
                    }
                    if (sankey_link_value.extension) {
                        sankey_link_value.extension.mini = the_mini;
                        sankey_link_value.extension.maxi = the_maxi;
                    }
                    //editable_link.value2['tags']['Uncert'] = {}
                    const p = (the_maxi - the_mini) / the_value;
                    if (p <= 0.1) {
                        sankey_link_value['tags']['Uncert'] = '10_percent';
                    }
                    else if (p <= 0.25) {
                        sankey_link_value['tags']['Uncert'] = '25_percent';
                    }
                    else if (p <= 0.5) {
                        sankey_link_value['tags']['Uncert'] = '50_percent';
                    }
                    else {
                        sankey_link_value['tags']['Uncert'] = '50+_percent';
                    }
                }
                if (data_to_convert.dataTags['flux_types']) {
                    sankey_link_value['tags']['flux_types'] = 'computed_data';
                }
                if (editable_link.data_value !== undefined && editable_link.data_value !== null && sankey_link_value.extension) {
                    sankey_link_value.extension.data_value = editable_link.data_value[0];
                    sankey_link_value['tags']['flux_types'] = 'initial_data';
                }
                if ('data_source' in editable_link && sankey_link_value.extension) {
                    sankey_link_value.extension.data_source = editable_link.data_source[0];
                }
                if ('data_period' in editable_link && sankey_link_value.extension) {
                    sankey_link_value.extension.data_period = editable_link.data_period[0];
                }
            });
        }
        Object.values(data.links).forEach(link => {
            (data.links[link.idLink]).value = data.links[link.idLink].value2;
            if (data.links[link.idLink].value2) {
                delete data.links[link.idLink].value2;
            }
        });
    }
    const convert_display = (dataTags, v, depth) => {
        if (dataTags.length == 0 || depth === dataTags.length) {
            if (v.display_value === undefined) {
                v.display_value = '';
            }
            else if (v.display_value === 'default') {
                v.display_value = '';
            }
            else if (v.display_value.includes('[')) {
                // Variables libres
                let tmp;
                if (v.display_value.includes('-')) {
                    tmp = v.display_value.split('-');
                }
                else if (v.display_value.includes(',')) {
                    tmp = v.display_value.split(',');
                }
                else if (v.display_value.includes('...')) {
                    tmp = v.display_value.split('...');
                }
                else if (v.display_value.includes('  ')) {
                    tmp = v.display_value.split('  ');
                }
                else {
                    tmp = v.display_value.split(' ');
                }
                const free_mini = Number(tmp[0].substring(1));
                const free_maxi = Number(tmp[1].substring(0, tmp[1].length - 1));
                if (!v.extension) {
                    v.extension = {};
                }
                if (v.extension) {
                    v.extension.free_mini = free_mini;
                    v.extension.free_maxi = free_maxi;
                }
                v.display_value = '';
            }
            const col_tag = v.color_tag;
            if (col_tag) {
                v.tags = Object.assign({}, col_tag);
                if (Array.isArray(v.tags['Uncert'])) {
                    v.tags['Uncert'] = v.tags['Uncert'][0];
                }
                delete v.color_tag;
            }
            if (v.tags === undefined) {
                v.tags = {};
            }
            if (!v.extension) {
                v.extension = {};
            }
            if (data_to_convert.fluxTags['flux_types'] && !('flux_types' in v['tags'])) {
                if (v.extension.data_value) {
                    v['tags']['flux_types'] = 'initial_data';
                }
                else {
                    v['tags']['flux_types'] = 'computed_data';
                }
            }
            return;
        }
        const dataTag = Object.values(dataTags)[depth];
        const listKey = Object.keys(dataTag.tags);
        for (const i in listKey) {
            if (v[listKey[i]]) {
                if (v === undefined) {
                    //console.log(listKey[i] + ' not found in v')
                    break;
                }
                convert_display(dataTags, v[listKey[i]], depth + 1);
            }
        }
    };
    const dataTagsArray = Object.values(data.dataTags).filter(dataTag => { return (Object.keys(dataTag.tags).length != 0) ? true : false; });
    Object.values(data.links).forEach(l => {
        convert_display(dataTagsArray, l.value, 0);
        if (!l.opacity) {
            l.opacity = 0.85;
        }
    });
};
exports.convert_links = convert_links;
const convert_data = (data) => {
    const data_to_convert = data;
    // let recompute_input_output_links = true
    // Object.values(data.nodes).forEach(n => {
    //   if (n.inputLinksId || n.outputLinksId) {
    //     recompute_input_output_links = false
    //   }
    //   if (!n.inputLinksId) {
    //     n.inputLinksId = []
    //   }
    //   if (!n.outputLinksId) {
    //     n.outputLinksId = []
    //   }
    // })
    // if (recompute_input_output_links) {
    //   compute_default_input_outputLinksId(data.nodes,data.links)
    // }
    const { display_style, units_names } = data_to_convert;
    if (display_style.font_family_selected) {
        display_style.node_font_family_selected = display_style.font_family_selected;
        display_style.link_font_family_selected = display_style.font_family_selected;
    }
    display_style.font_family = ['Arial,sans-serif', 'Helvetica,sans-serif', 'Verdana,sans-serif', 'Calibri,sans-serif', 'Noto,sans-serif', 'Lucida Sans,sans-serif', 'Gill Sans,sans-serif', 'Century Gothic,sans-serif', 'Candara,sans-serif', 'Futara,sans-serif', 'Franklin Gothic Medium,sans-serif', 'Trebuchet MS,sans-serif', 'Geneva,sans-serif', 'Segoe UI,sans-serif', 'Optima,sans-serif', 'Avanta Garde,sans-serif',
        'Times New Roman,serif', 'Big Caslon,serif', 'Bodoni MT,serif', 'Book Antiqua,serif', 'Bookman,serif', 'New Century Schoolbook,serif', 'Calisto MT,serif', 'Cambria,serif', 'Didot,serif', 'Garamond,serif', 'Georgia,serif', 'Goudy Old Style,serif', 'Hoefler Text,serif', 'Lucida Bright,serif', 'Palatino,serif', 'Perpetua,serif', 'Rockwell,serif', 'Rockwell Extra Bold,serif', 'Baskerville,serif',
        'Consolas,monospace', 'Courier,monospace', 'Courier New,monospace', 'Lucida Console,monospace', 'Lucidatypewriter,monospace', 'Lucida Sans Typewriter,monospace', 'Monaco,monospace', 'Andale Mono,monospace',
        'Comic Sans,cursive', 'Comic Sans MS,cursive', 'Apple Chancery,cursive', 'Zapf Chancery,cursive', 'Bradley Hand,cursive', 'Brush Script MT,cursive', 'Brush Script Std,cursive', 'Snell Roundhan,cursive', 'URW Chancery,cursive', 'Coronet script,cursive', 'Florence,cursive', 'Parkavenue,cursive'
    ];
    if (display_style.trade_close === undefined && (data.version === '0.2' || data.version === '0.3')) {
        display_style.trade_close = true;
    }
    if (data.version === '0.1') {
        display_style.trade_close = false;
    }
    if (data_to_convert.display_style.unit === 1) {
        data_to_convert.display_style.unit = true;
    }
    const attributes_to_remove = ['agregated_level', 'show_data', 'trade_close', 'sankey_type', 'previous_filter', 'filtered_links', 'filtered_nodes_names', 'filtered_nodes', 'nodes_names', 'max_vertical_offset', 'error', 'nodes2units_conv', 'nodes2tooltips'];
    for (const attr in attributes_to_remove) {
        if (attributes_to_remove[attr] in data) {
            delete data[attributes_to_remove[attr]];
        }
    }
    if (data.show_structure === false || data.show_structure === true) {
        data.show_structure = 'reconciled';
    }
    if (data.version === '0.1') {
        units_names.splice(1, 0, 'natural');
    }
    // if (data.colorMap === 'no_colormap' ) {
    //   Object.values(data.links).forEach(el => {
    //     el.colorParameter = 'local'
    //     el.colorTag = 'no_colormap'
    //   })
    // }
    exports.convert_tags(data);
    exports.convert_nodes(data);
    exports.convert_links(data);
    // Convert Data labes
    Object.values(data_to_convert.labels).forEach(l => {
        if (l.isTextHTML === undefined) {
            l.isTextHTML = false;
            l.is_edit_raw = true;
        }
        if (['haut', 'bas'].includes(l.position_vert)) {
            if (l.position_vert == 'haut') {
                l.position_vert = 'top';
            }
            else if (l.position_vert == 'bas') {
                l.position_vert = 'bottom';
            }
        }
        if (['gauche', 'droite'].includes(l.position_horiz)) {
            if (l.position_horiz == 'gauche') {
                l.position_horiz = 'left';
            }
            else if (l.position_horiz == 'droite') {
                l.position_horiz = 'right';
            }
        }
        // CONVERT TEXT ZONE TRANSPARENT -> OPACITY (0-100)
        if (l.transparent !== undefined) {
            l.opacity = l.transparent ? 0 : 100;
            delete l.transparent;
        }
    });
    if (!data_to_convert.view) {
        return;
    }
    const deep_diff = require('deep-diff');
    data_to_convert.view.forEach(v => {
        if (v.view_data.version) {
            exports.convert_tags(v.view_data);
            exports.convert_nodes(v.view_data);
            exports.convert_links(v.view_data);
            let difference = deep_diff.diff(data, v.view_data);
            difference = (difference !== undefined) ? difference : [];
            difference = JSON.parse(JSON.stringify(difference)).map((d) => {
                if (d.kind == 'D') {
                    delete d.lhs;
                }
                if (d.kind == 'A' && d.item.kind == 'D') {
                    delete d.item.lhs;
                }
                if (d.kind == 'E') {
                    delete d.lhs;
                }
                return d;
            });
            difference = difference.filter((d) => !d.path.includes('view'));
            v.view_data = {};
            v.view_data.diff = difference;
        }
    });
    // data_to_convert.view.forEach(v=>{
    //   convert_tags(v.view_data as unknown as SankeyData)
    //   convert_nodes(v.view_data as unknown as SankeyData)
    //   convert_links(v.view_data as unknown as SankeyData)
    // })
};
exports.convert_data = convert_data;
